import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { action, select } from 'satcheljs/lib/legacy';
import { getMailboxJunkEmailConfiguration, saveMailboxJunkEmailConfiguration, } from 'owa-junkmail-configuration';
import { isEmailAddress } from 'owa-mail-option-common';
export default select({
    mailboxJunkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
    optionState: function () { return store; },
})(action('saveBlockedSendersOption')(function saveBlockedSendersOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, mailboxJunkEmailConfiguration, optionState, blockedSenders, blockedDomains, blockedSenderAndDomains;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = state, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration, optionState = _a.optionState;
                    blockedSenders = getFallbackValueIfNull(optionState.blockedSenders, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) {
                        return isEmailAddress(item);
                    }));
                    blockedDomains = mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !isEmailAddress(item); });
                    blockedSenderAndDomains = blockedSenders.slice(0).concat(blockedDomains);
                    mailboxJunkEmailConfiguration.BlockedSendersAndDomains = blockedSenderAndDomains;
                    return [4 /*yield*/, saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveBlockedSendersOption.js.map